import { useQuery } from "@tanstack/react-query";
import { publicApi } from "@/lib/api";
import { useContent } from "@/lib/content";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQs() {
  const { data: faqs = [] } = useQuery({ queryKey: ["faqs"], queryFn: async () => (await publicApi.get("/faqs")).data });
  const { t } = useContent();

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="mb-10">
        <p className="overline-label mb-2">{t("faqs.overline")}</p>
        <h1 className="font-serif text-4xl lg:text-5xl text-cream">{t("faqs.title")}</h1>
      </div>
      <Accordion type="single" collapsible className="space-y-3">
        {faqs.map((f) => (
          <AccordionItem key={f.id} value={f.id} data-testid={`faq-${f.id}`} className="gold-card !border-gold/20 px-5">
            <AccordionTrigger className="text-cream hover:text-gold text-left font-serif text-lg">{f.question}</AccordionTrigger>
            <AccordionContent className="text-muted2 leading-relaxed">{f.answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
